import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-collection" }
const _hoisted_2 = { class: "content" }

import type { CollectionType } from "@/common/types/collection";

import {
  TabDetailManufacturer,
  TabDetailGender,
  TabDetailRegion,
  TabDetailRelease,
  TabDetailFranchise,
  TabDetailMedia,
  TabDetailLanguage,
  TabDetailTag,
} from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'details',
  props: {
    collection: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TabDetailTag), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailRegion), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailLanguage), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailManufacturer), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailMedia), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailRelease), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailFranchise), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"]),
      _createVNode(_unref(TabDetailGender), {
        "collection-id": __props.collection.collection_id
      }, null, 8, ["collection-id"])
    ])
  ]))
}
}

})